import { Lock } from "lucide-react";
import { Badge } from "./Badge";

interface NoAccessBadgeProps {
  className?: string;
  text?: string;
  iconSize?: number;
}

export const NoAccessBadge = ({
  className,
  text = "No access",
  iconSize = 14,
}: NoAccessBadgeProps) => {
  return (
    <Badge
      variant="neutral"
      size="md"
      icon={<Lock size={iconSize} aria-hidden="true" />}
      iconPosition="left"
      className={className}
      ariaLabel={text}
    >
      {text}
    </Badge>
  );
};
